import { noPriorityOption, Task, TaskPriorityOptions } from '@griply/types';

export type PriorityGroupedTasks = {
  priority: string;
  tasks: Task[];
};

export type GroupTasksByPriorityOptions = {
  tasks: Task[];
};

const priorityOrder = [
  TaskPriorityOptions.High,
  TaskPriorityOptions.Medium,
  TaskPriorityOptions.Low,
  noPriorityOption,
];

export const groupTasksByPriority = (
  options: GroupTasksByPriorityOptions,
): PriorityGroupedTasks[] => {
  const { tasks } = options;

  // 1. Create Map with fixed priority buckets
  const groupMap = new Map<string, Task[]>();

  for (const priority of priorityOrder) {
    groupMap.set(priority, []);
  }

  // 2. Assign tasks to groups
  for (const task of tasks) {
    const targetId =
      !task.priority || task.priority === TaskPriorityOptions.None
        ? noPriorityOption
        : task.priority;
    const group = groupMap.get(targetId);
    if (group) {
      group.push(task);
    }
  }

  // 3. Filter out empty groups, maintaining fixed order
  const nonEmptyGroups: PriorityGroupedTasks[] = [];
  for (const priority of priorityOrder) {
    const taskList = groupMap.get(priority);
    if (!taskList?.length) {
      continue;
    }

    nonEmptyGroups.push({
      priority,
      tasks: taskList,
    });
  }

  return nonEmptyGroups;
};
